var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.layout},[_c('HeaderLayout'),_c('main',{class:_vm.$style.main},[_vm._t("default")],2),_c('FooterLayout'),_c('BaseModal',[_c('ModalSessionDemo')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }